import classNames from 'classnames'
import { forwardRef, useEffect, useRef, useState } from 'react'
import { createUseStyles } from 'react-jss'
import style from './style'

const useStyles = createUseStyles(style)

function mapRange(num, inMin, inMax, outMin, outMax) {
  // eslint-disable-next-line no-mixed-operators
  return ((num - inMin) * (outMax - outMin)) / (inMax - inMin) + outMin
}

const clamp = (num, min, max) => Math.min(Math.max(num, min), max)

const SliderRange = forwardRef(
  ({
    className,
    min,
    max,
    minRange,
    maxRange,
    thumbRadius = 18,
    onChange = () => {},
    label,
    reload,
  }, ref) => {
    const classes = useStyles({
      thumbRadius,
    })

    const [$rail, setRail] = useState(null)
    const $thumb1 = useRef()
    const $thumb2 = useRef()
    const $track = useRef()

    const [minValue, setMinValue] = useState(min)
    const [maxValue, setMaxValue] = useState(max)
    const [pointerDown, setPointerDown] = useState(null)
    const [railBounds, setRailBounds] = useState(null)

    const handleResize = () => {
      if ($rail) {
        setRailBounds($rail.getBoundingClientRect())
      }
    }

    /*--------------------
    Init
    --------------------*/
    useEffect(() => {
      if ($rail || reload) {
        handleResize()
        window.addEventListener('resize', handleResize)
      }

      return () => {
        window.removeEventListener('resize', handleResize)
      }
    }, [$rail, reload])

    /*--------------------
    Change Values
    --------------------*/
    useEffect(() => {
      if (!railBounds) return
      const thumb1X = mapRange(
        minValue,
        minRange,
        maxRange,
        0,
        railBounds.width - thumbRadius,
      )
      const thumb2X = mapRange(
        maxValue,
        minRange,
        maxRange,
        0,
        railBounds.width - thumbRadius,
      )

      $thumb2.current.style.left = `${thumb2X}px`
      $thumb1.current.style.left = `${thumb1X}px`

      $track.current.style.left = `${thumb1X}px`
      $track.current.style.width = `${thumb2X - thumb1X}px`
    }, [minValue, maxValue, minRange, maxRange, railBounds])

    /*--------------------
    PointerUp
    --------------------*/
    const handlePointerUp = () => {
      setPointerDown(null)
    }

    /*--------------------
    PointerMove
    --------------------*/
    const handlePointerMove = (e) => {
      const mouseX = e.touches ? e.touches[0].clientX : e.clientX || e.pageX

      if (pointerDown.dataset.index === '0') {
        const x = clamp(
          mouseX - railBounds.x - thumbRadius * 0.5,
          0,
          railBounds.width,
        )
        setMinValue(
          clamp(
            Math.round(mapRange(x, 0, railBounds.width, minRange, maxRange)),
            minRange,
            maxValue - 20,
          ),
        )
      } else {
        const x = clamp(
          mouseX - railBounds.x,
          0,
          railBounds.width,
        )
        setMaxValue(
          clamp(
            Math.round(mapRange(x, 0, railBounds.width, minRange, maxRange)),
            minValue + 20,
            maxRange,
          ),
        )
      }
    }

    /*--------------------
    Window Listener
    --------------------*/
    useEffect(() => {
      document.body.style.cursor = pointerDown ? 'grabbing' : ''
      window.addEventListener('mouseup', handlePointerUp, false)
      window.addEventListener('touchend', handlePointerUp, false)

      if (pointerDown) {
        window.addEventListener('mousemove', handlePointerMove, false)
        window.addEventListener('touchmove', handlePointerMove, false)
      } else {
        onChange({ min: minValue, max: maxValue })
      }

      return () => {
        window.removeEventListener('mouseup', handlePointerUp)
        window.removeEventListener('touchend', handlePointerUp)
        window.removeEventListener('mousemove', handlePointerMove)
        window.removeEventListener('touchmove', handlePointerMove)
      }
    }, [pointerDown])

    return (
      <div
        ref={ref}
        className={classNames({
          [classes.root]: true,
          [className]: true,
        })}
      >
        <div className={classes.values}>
          {`${minValue}${label} - ${maxValue}${label}`}
        </div>
        <span
          className={classes.rail}
          ref={(r) => {
            setRail(r)
          }}
        />
        <span className={classes.track} ref={$track} />

        <span
          ref={$thumb1}
          onPointerDown={() => setPointerDown($thumb1.current)}
          data-index="0"
          className={classNames({
            [classes.thumb]: true,
            [classes.active]: pointerDown === $thumb1.current,
          })}
        >
          {/*  <span
            className={classNames({
              [classes.value]: true,
              [classes.minValue]: true,
            })}
          >
            {minValue}
            {label}
          </span> */}
        </span>

        <span
          ref={$thumb2}
          onPointerDown={() => setPointerDown($thumb2.current)}
          data-index="1"
          className={classNames({
            [classes.thumb]: true,
            [classes.active]: pointerDown === $thumb2.current,
          })}
        >
          {/*  <span
            className={classNames({
              [classes.value]: true,
              [classes.maxValue]: true,
            })}
          >
            {maxValue}
            {label}
          </span> */}
        </span>
      </div>
    )
  },
)

export default SliderRange
